import { SmthBanner } from "../../../shared/pages/opencallsPage/GetCompetitionItem/style";
import { useTranslation } from "react-i18next";
import { FC } from "react";
import { PopUpMenu } from "shared/pages/opencallsPage/GetCompetitionItem/PopUpMenu";
import { FlexBox, ResizedImage, useIsMobile, usePagination } from "@brg/ui";
import { useMemo, useCallback, useEffect, useState } from "react";
import { ProjectsSearchBar } from "../../../shared/components/projectsSearchBar/projectsSearchBar";

import {
  CompetitionAPI,
  Competition,
  API,
  Project,
  Endpoints,
  PageModel,
} from "@brg/api";
import { useParams } from "react-router-dom";
import useDocumentTitle from "shared/hooks/useDocumentTitle";
import { Outer } from "shared/pages/explore/styles";
import { bProfile, useAuth } from "@brg/auth";
import { SortingTypeIndex } from "shared/constants/sortingType";
import {
  ListOuter,
  ShortListLabel,
  WinnerDescription,
  WinnerPlace,
  WinnerProjectWrapper,
  WinnersBox,
  WinnerText,
} from "./styles";
import ProjectCardNew from "shared/components/projectCard/projectCardNew";
import { ItemType } from "shared/constants/itemType";
import { CompetitionShowMoreContent } from "../AllCompetitionsPage/styled";
import { ProjectsGridNew } from "shared/components/grids";
import { Pagination } from "shared/components/pagination";
import { computeProject } from "../../../shared/helpers/types/computed/ComputedProject";

export const ShortListPage: FC<{
  openLikeTab?: boolean;
  externalId?: string;
  showPreShortList?: boolean;
  activeTabKey?: string;
}> = ({ openLikeTab, externalId }) => {
  const { t, i18n } = useTranslation();
  const { associatedProfile, token } = useAuth();
  const isMobile = useIsMobile();
  const [selectedTab, setSelectedTab] = useState("projects");
  const { id = externalId } = useParams<{ id: string }>();
  const [sorting, setSorting] = useState(1);

  useDocumentTitle(id, "competition");

  const [competition, setCompetition] = useState<Competition>();
  const [winnerProjects, setWinnerProjects] = useState<
    { project: Project; position: number }[]
  >([]);
  const [finalistsProjects, setFinalistsProjects] = useState<
    { project: Project; position: number }[]
  >([]);
  const [visiblePopUp, setIsVisiblePopUp] = useState<boolean>(false);
  const [banMobileTabs, setBanMobileTabs] = useState<string[]>([""]);
  const profile = token ? associatedProfile : undefined;

  const finalistsPagination = usePagination(finalistsProjects, 20);

  const isModer = useMemo(
    () => profile && bProfile.isModer(profile),
    [profile]
  );

  const showProjects = useMemo(
    // @ts-ignore
    () => competition?.nominations[0]?.showShortList || isModer,
    [competition, isModer]
  );

  const sortWinners = useMemo(
    () =>
      winnerProjects?.sort((a, b) => {
        if (a?.position > b?.position) {
          return 1;
        }
        return -1;
      }),
    [winnerProjects]
  );

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
  }, []);

  const searchBar = useMemo(
    () => (
      <ProjectsSearchBar
        isLoading={false}
        isCategoriesHidden={true}
        hideRightButtons
        hideLeftBar
        sorting={sorting}
        hideRightBar={true}
        onSortingChange={onSortingChange}
      />
    ),
    [onSortingChange, sorting]
  );

  const winnerIntroText = useMemo(
    //@ts-ignore
    () => competition && competition?.winnerText_Intro,
    [competition]
  );

  const winnerFinalText = useMemo(
    //@ts-ignore
    () => competition && competition?.winnerText_Final,
    [competition]
  );

  const [expanded, setExpanded] = useState(false);
  const [winnerExpanded, setWinnerExpanded] = useState(false);

  const handleDescriptionExpanded = () => {
    setExpanded((prev) => !prev);
  };
  const handleWinnerDescription = () => {
    setWinnerExpanded((prev) => !prev);
  };

  const ShowMore = (props: any) => (
    <CompetitionShowMoreContent {...props}>
      {props.children}
    </CompetitionShowMoreContent>
  );

  useEffect(() => {
    if (id) {
      CompetitionAPI.Get({ idCompetition: id })
        .then((r) => r.json())
        .then((v) => API.toLang<Competition>(v, i18n.language))
        .then((v) => {
          setCompetition(v);
        });
    }
  }, [id, i18n]);

  useEffect(() => {
    if (competition) {
      //@ts-ignore
      const winnersIds: srting[] = competition?.nominations[0]?.winnerPositions.map((x) => x.winnerId);
      const finalistsIds = competition?.nominations[0]?.finalistsID;

      var apiCall = (projectIds: string[]) => {
        return API.request()
          .post()
          .endpoint(Endpoints.geograffee)
          .url(`api/project/GetProjectsList`)
          .body({
            projectIds,
            projectFilter: 1,
            isContextIgnored: true,
          })
          .send()
          .then((v) => v.json())
          .then((v) => API.toLang<PageModel<Project>>(v, i18n.language));
      };

      if (finalistsIds && finalistsIds.length !== 0) {
        apiCall(finalistsIds).then((v) => {
          const arr = v.data.map((x) => {
            return { project: x, position: 0 };
          });
          setFinalistsProjects(arr);
        });
      }

      if (winnersIds && winnersIds.length !== 0) {
        apiCall(winnersIds).then((v) => {
          const arr = v.data.map((x) => {
            //@ts-ignore
            var temp = competition?.nominations[0]?.winnerPositions.find(
              (f: any) => f.winnerId === x.projectId
            );

            return { project: x, position: temp?.position ?? 1 };
          });

          setWinnerProjects(arr);
        });
      }
    }
  }, [competition, i18n.language]);

  useEffect(() => {
    if (
      competition &&
      competition?.juryID &&
      competition?.juryID.length === 0
    ) {
      setBanMobileTabs(["jury"]);
    } else {
      setBanMobileTabs([""]);
    }
  }, [competition]);
  const calcGridColumn = useCallback(
    (winnerProject: any) => {

      return ['t-shape', 'fixed-ratio-small', 'fixed-ratio-large'].includes(winnerProject.project?.projectType) ? true : false;
    }, [])


  if (openLikeTab) {
    return (
      <ListOuter style={{ marginTop: isMobile ? 0 : "24px", padding: 0 }}>
        <FlexBox align="center" offsetTopMobile={10}>
          {searchBar}
        </FlexBox>
        {winnerIntroText && (
          <WinnerDescription offsetBottom={32} offsetBottomMobile={24}>
            <ShowMore
              importantStyles
              more={t("show_more_text")}
              less={t("show_less_text")}
              lines={5}
              expanded={expanded}
              onClick={handleDescriptionExpanded}
            >
              {<div dangerouslySetInnerHTML={{ __html: winnerIntroText }} />}
            </ShowMore>
          </WinnerDescription>
        )}
        <WinnersBox mobile={isMobile}>
          {!!sortWinners?.length
            ? sortWinners.map((winnerProject) => {
              return (
                <WinnerProjectWrapper isLargeProject={calcGridColumn(winnerProject)} key={winnerProject.project.projectId}>
                  <WinnerPlace>
                    <WinnerText>{winnerProject.position}</WinnerText>
                    <WinnerText>{t("competition.short_list.place")}</WinnerText>
                  </WinnerPlace>
                  <ProjectCardNew
                    project={winnerProject.project}
                    {...computeProject(winnerProject.project)}
                    itemType={calcGridColumn(winnerProject) ? ItemType.competition : ItemType.book}
                    isModal={false}
                    withoutGoToProject={false}
                    isSelectable={false}
                  />
                </WinnerProjectWrapper>
              );
            })
            : false}
        </WinnersBox>
        {winnerFinalText && (
          <WinnerDescription offsetTop={32} offsetTopMobile={24}>
            <ShowMore
              importantStyles
              more={t("show_more_text")}
              less={t("show_less_text")}
              lines={4}
              expanded={winnerExpanded}
              onClick={handleWinnerDescription}
            >
              {winnerFinalText}
            </ShowMore>
          </WinnerDescription>
        )}
        {finalistsProjects?.length > 0 && showProjects && (
          <FlexBox
            direction="column"
            directionMobile="column"
            offsetTopMobile={19}
            id="shortlist-scroll-target"
          >
            <ShortListLabel>
              {t("competition.short_list.shortlist")}
            </ShortListLabel>
            <ProjectsGridNew k={20} isLoading={false} itemType={ItemType.book}>
              {finalistsPagination.items?.map(
                (proj: { project: Project; position: Number }) => {
                  return (
                    <ProjectCardNew
                      key={proj.project.projectId}
                      project={proj.project}
                      itemType={ItemType.book}
                      isModal={false}
                      withoutGoToProject={false}
                      {...computeProject(proj.project)}
                      isSelectable={false}
                    />
                  );
                })}
            </ProjectsGridNew>
            <Pagination {...finalistsPagination} scrollTarget="#shortlist-scroll-target" />
          </FlexBox>
        )}
      </ListOuter>
    );
  }

  return (
    <>
      <PopUpMenu
        key="menu-popup-deziiign"
        isVisible={visiblePopUp}
        onClose={() => setIsVisiblePopUp(false)}
        activeTab={selectedTab}
        showOnlyTabs
        banTabs={banMobileTabs}
      />
      <Outer style={{ marginTop: "64px" }}>
        <SmthBanner isHideMarginBottom isMobile={isMobile}>
          <ResizedImage files={competition?.titleImages} />
        </SmthBanner>
        <FlexBox align="center" offsetTop={32}>
          {searchBar}
        </FlexBox>
        <WinnersBox mobile={isMobile}>
          {!!sortWinners?.length
            ? sortWinners.map((winnerProject) => (
              <WinnerProjectWrapper key={winnerProject.project.projectId}>
                <WinnerPlace>
                  <WinnerText>{winnerProject.position}</WinnerText>
                  <WinnerText>{t("competition.short_list.place")}</WinnerText>
                </WinnerPlace>
                {
                  //@ts-ignore
                  <ProjectCardNew
                    project={winnerProject.project}
                    {...computeProject(winnerProject.project)}
                    itemType={ItemType.book}
                    isModal={false}
                    withoutGoToProject={false}
                    isSelectable={false}
                  />
                }
              </WinnerProjectWrapper>
            ))
            : false}
        </WinnersBox>
        {finalistsProjects?.length > 0 && showProjects && (
          <FlexBox
            direction="column"
            directionMobile="column"
            offsetTopMobile={19}
          >
            <ShortListLabel>
              {t("competition.short_list.shortlist")}
            </ShortListLabel>
            <ProjectsGridNew k={20} isLoading={false}>
              {finalistsPagination.items?.map(
                (proj: { project: Project; position: Number }) => {
                  return (
                    <ProjectCardNew
                      key={proj.project.projectId}
                      project={proj.project}
                      itemType={ItemType.book}
                      isModal={false}
                      withoutGoToProject={false}
                      {...computeProject(proj.project)}
                      isSelectable={false}
                    />
                  );
                }
              )}
            </ProjectsGridNew>
            <Pagination {...finalistsPagination} scrollTarget="#shortlist-scroll-target" />
          </FlexBox>
        )}
      </Outer>
    </>
  );
};
import { SmthBanner } from "../../../shared/pages/opencallsPage/GetCompetitionItem/style";
import { useTranslation } from "react-i18next";
import { FC } from "react";
import { PopUpMenu } from "shared/pages/opencallsPage/GetCompetitionItem/PopUpMenu";
import { FlexBox, ResizedImage, useIsMobile, usePagination } from "@brg/ui";
import { useMemo, useCallback, useEffect, useState } from "react";
import { ProjectsSearchBar } from "../../../shared/components/projectsSearchBar/projectsSearchBar";

import {
  CompetitionAPI,
  Competition,
  API,
  Project,
  Endpoints,
  PageModel,
} from "@brg/api";
import { useParams } from "react-router-dom";
import useDocumentTitle from "shared/hooks/useDocumentTitle";
import { Outer } from "shared/pages/explore/styles";
import { bProfile, useAuth } from "@brg/auth";
import { SortingTypeIndex } from "shared/constants/sortingType";
import {
  ListOuter,
  ShortListLabel,
  WinnerDescription,
  WinnerPlace,
  WinnerProjectWrapper,
  WinnersBox,
  WinnerText,
} from "./styles";
import ProjectCardNew from "shared/components/projectCard/projectCardNew";
import { ItemType } from "shared/constants/itemType";
import { CompetitionShowMoreContent } from "../AllCompetitionsPage/styled";
import { ProjectsGridNew } from "shared/components/grids";
import { Pagination } from "shared/components/pagination";
import { computeProject } from "../../../shared/helpers/types/computed/ComputedProject";

export const ShortListPage: FC<{
  openLikeTab?: boolean;
  externalId?: string;
  showPreShortList?: boolean;
  activeTabKey?: string;
}> = ({ openLikeTab, externalId }) => {
  const { t, i18n } = useTranslation();
  const { associatedProfile, token } = useAuth();
  const isMobile = useIsMobile();
  const [selectedTab, setSelectedTab] = useState("projects");
  const { id = externalId } = useParams<{ id: string }>();
  const [sorting, setSorting] = useState(1);

  useDocumentTitle(id, "competition");

  const [competition, setCompetition] = useState<Competition>();
  const [winnerProjects, setWinnerProjects] = useState<
    { project: Project; position: number }[]
  >([]);
  const [finalistsProjects, setFinalistsProjects] = useState<
    { project: Project; position: number }[]
  >([]);
  const [visiblePopUp, setIsVisiblePopUp] = useState<boolean>(false);
  const [banMobileTabs, setBanMobileTabs] = useState<string[]>([""]);
  const profile = token ? associatedProfile : undefined;

  const finalistsPagination = usePagination(finalistsProjects, 20);

  const isModer = useMemo(
    () => profile && bProfile.isModer(profile),
    [profile]
  );

  const showProjects = useMemo(
    // @ts-ignore
    () => competition?.nominations[0]?.showShortList || isModer,
    [competition, isModer]
  );

  const sortWinners = useMemo(
    () =>
      winnerProjects?.sort((a, b) => {
        if (a?.position > b?.position) {
          return 1;
        }
        return -1;
      }),
    [winnerProjects]
  );

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
  }, []);

  const searchBar = useMemo(
    () => (
      <ProjectsSearchBar
        isLoading={false}
        isCategoriesHidden={true}
        hideRightButtons
        hideLeftBar
        sorting={sorting}
        hideRightBar={true}
        onSortingChange={onSortingChange}
      />
    ),
    [onSortingChange, sorting]
  );

  const winnerIntroText = useMemo(
    //@ts-ignore
    () => competition && competition?.winnerText_Intro,
    [competition]
  );

  const winnerFinalText = useMemo(
    //@ts-ignore
    () => competition && competition?.winnerText_Final,
    [competition]
  );

  const [expanded, setExpanded] = useState(false);
  const [winnerExpanded, setWinnerExpanded] = useState(false);

  const handleDescriptionExpanded = () => {
    setExpanded((prev) => !prev);
  };
  const handleWinnerDescription = () => {
    setWinnerExpanded((prev) => !prev);
  };

  const ShowMore = (props: any) => (
    <CompetitionShowMoreContent {...props}>
      {props.children}
    </CompetitionShowMoreContent>
  );

  useEffect(() => {
    if (id) {
      CompetitionAPI.Get({ idCompetition: id })
        .then((r) => r.json())
        .then((v) => API.toLang<Competition>(v, i18n.language))
        .then((v) => {
          setCompetition(v);
        });
    }
  }, [id, i18n]);

  useEffect(() => {
    if (competition) {
      //@ts-ignore
      const winnersIds: srting[] = competition?.nominations[0]?.winnerPositions.map((x) => x.winnerId);
      const finalistsIds = competition?.nominations[0]?.finalistsID;

      var apiCall = (projectIds: string[]) => {
        return API.request()
          .post()
          .endpoint(Endpoints.geograffee)
          .url(`api/project/GetProjectsList`)
          .body({
            projectIds,
            projectFilter: 1,
            isContextIgnored: true,
          })
          .send()
          .then((v) => v.json())
          .then((v) => API.toLang<PageModel<Project>>(v, i18n.language));
      };

      if (finalistsIds && finalistsIds.length !== 0) {
        apiCall(finalistsIds).then((v) => {
          const arr = v.data.map((x) => {
            return { project: x, position: 0 };
          });
          setFinalistsProjects(arr);
        });
      }

      if (winnersIds && winnersIds.length !== 0) {
        apiCall(winnersIds).then((v) => {
          const arr = v.data.map((x) => {
            //@ts-ignore
            var temp = competition?.nominations[0]?.winnerPositions.find(
              (f: any) => f.winnerId === x.projectId
            );

            return { project: x, position: temp?.position ?? 1 };
          });

          setWinnerProjects(arr);
        });
      }
    }
  }, [competition, i18n.language]);

  useEffect(() => {
    if (
      competition &&
      competition?.juryID &&
      competition?.juryID.length === 0
    ) {
      setBanMobileTabs(["jury"]);
    } else {
      setBanMobileTabs([""]);
    }
  }, [competition]);
  const calcGridColumn = useCallback(
    (winnerProject: any) => {

      return ['t-shape', 'fixed-ratio-small', 'fixed-ratio-large'].includes(winnerProject.project?.projectType) ? true : false;
    }, [])


  if (openLikeTab) {
    return (
      <ListOuter style={{ marginTop: isMobile ? 0 : "24px", padding: 0 }}>
        <FlexBox align="center" offsetTopMobile={10}>
          {searchBar}
        </FlexBox>
        {winnerIntroText && (
          <WinnerDescription offsetBottom={32} offsetBottomMobile={24}>
            <ShowMore
              importantStyles
              more={t("show_more_text")}
              less={t("show_less_text")}
              lines={5}
              expanded={expanded}
              onClick={handleDescriptionExpanded}
            >
              {<div dangerouslySetInnerHTML={{ __html: winnerIntroText }} />}
            </ShowMore>
          </WinnerDescription>
        )}
        <WinnersBox mobile={isMobile}>
          {!!sortWinners?.length
            ? sortWinners.map((winnerProject) => {
              return (
                <WinnerProjectWrapper isLargeProject={calcGridColumn(winnerProject)} key={winnerProject.project.projectId}>
                  <WinnerPlace>
                    <WinnerText>{winnerProject.position}</WinnerText>
                    <WinnerText>{t("competition.short_list.place")}</WinnerText>
                  </WinnerPlace>
                  <ProjectCardNew
                    project={winnerProject.project}
                    {...computeProject(winnerProject.project)}
                    itemType={calcGridColumn(winnerProject) ? ItemType.competition : ItemType.book}
                    isModal={false}
                    withoutGoToProject={false}
                    isSelectable={false}
                  />
                </WinnerProjectWrapper>
              );
            })
            : false}
        </WinnersBox>
        {winnerFinalText && (
          <WinnerDescription offsetTop={32} offsetTopMobile={24}>
            <ShowMore
              importantStyles
              more={t("show_more_text")}
              less={t("show_less_text")}
              lines={4}
              expanded={winnerExpanded}
              onClick={handleWinnerDescription}
            >
              {winnerFinalText}
            </ShowMore>
          </WinnerDescription>
        )}
        {finalistsProjects?.length > 0 && showProjects && (
          <FlexBox
            direction="column"
            directionMobile="column"
            offsetTopMobile={19}
            id="shortlist-scroll-target"
          >
            <ShortListLabel>
              {t("competition.short_list.shortlist")}
            </ShortListLabel>
            <ProjectsGridNew k={20} isLoading={false} itemType={ItemType.book}>
              {finalistsPagination.items?.map(
                (proj: { project: Project; position: Number }) => {
                  return (
                    <ProjectCardNew
                      key={proj.project.projectId}
                      project={proj.project}
                      itemType={ItemType.book}
                      isModal={false}
                      withoutGoToProject={false}
                      {...computeProject(proj.project)}
                      isSelectable={false}
                    />
                  );
                })}
            </ProjectsGridNew>
            <Pagination {...finalistsPagination} scrollTarget="#shortlist-scroll-target" />
          </FlexBox>
        )}
      </ListOuter>
    );
  }

  return (
    <>
      <PopUpMenu
        key="menu-popup-deziiign"
        isVisible={visiblePopUp}
        onClose={() => setIsVisiblePopUp(false)}
        activeTab={selectedTab}
        showOnlyTabs
        banTabs={banMobileTabs}
      />
      <Outer style={{ marginTop: "64px" }}>
        <SmthBanner isHideMarginBottom isMobile={isMobile}>
          <ResizedImage files={competition?.titleImages} />
        </SmthBanner>
        <FlexBox align="center" offsetTop={32}>
          {searchBar}
        </FlexBox>
        <WinnersBox mobile={isMobile}>
          {!!sortWinners?.length
            ? sortWinners.map((winnerProject) => (
              <WinnerProjectWrapper key={winnerProject.project.projectId}>
                <WinnerPlace>
                  <WinnerText>{winnerProject.position}</WinnerText>
                  <WinnerText>{t("competition.short_list.place")}</WinnerText>
                </WinnerPlace>
                {
                  //@ts-ignore
                  <ProjectCardNew
                    project={winnerProject.project}
                    {...computeProject(winnerProject.project)}
                    itemType={ItemType.book}
                    isModal={false}
                    withoutGoToProject={false}
                    isSelectable={false}
                  />
                }
              </WinnerProjectWrapper>
            ))
            : false}
        </WinnersBox>
        {finalistsProjects?.length > 0 && showProjects && (
          <FlexBox
            direction="column"
            directionMobile="column"
            offsetTopMobile={19}
          >
            <ShortListLabel>
              {t("competition.short_list.shortlist")}
            </ShortListLabel>
            <ProjectsGridNew k={20} isLoading={false}>
              {finalistsPagination.items?.map(
                (proj: { project: Project; position: Number }) => {
                  return (
                    <ProjectCardNew
                      key={proj.project.projectId}
                      project={proj.project}
                      itemType={ItemType.book}
                      isModal={false}
                      withoutGoToProject={false}
                      {...computeProject(proj.project)}
                      isSelectable={false}
                    />
                  );
                }
              )}
            </ProjectsGridNew>
            <Pagination {...finalistsPagination} scrollTarget="#shortlist-scroll-target" />
          </FlexBox>
        )}
      </Outer>
    </>
  );
};
